var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "131 -131 512 512",
    style: {
      enableBackground: "new 131 -131 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B43434",
    d: "M387-14.8v69.9l93.4-93.4L387-131v69.9C284-61.1 200.9 22 200.9 125c0 36.8 11 70.6 28.7 99.3l33.8-33.8c-10.3-19.9-16.2-41.9-16.2-65.5 0-77.2 62.6-139.8 139.8-139.8zm157.4 40.5-33.8 33.8c10.3 19.9 16.2 41.9 16.2 65.5 0 77.2-62.5 139.8-139.8 139.8v-69.9l-93.4 93.4L387 381v-69.9c103 0 186.1-83.1 186.1-186.1 0-36.8-10.3-70.6-28.7-99.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/replace.c29f3515092b98b1ddfa839b6ee7fa2e.svg";
export { ForwardRef as ReactComponent };